import { createSlice } from '@reduxjs/toolkit';

export type channelsState = {
  channelList: any[];
};

const initialState: channelsState = { channelList: [] };

const channelsSlice = createSlice({
  name: 'channels',
  initialState: initialState,
  reducers: {
    handleChannelList(state, action) {
      state.channelList = action.payload;
    },
    addChannel(state, action) {
      state.channelList.push(action.payload);
    }
  }
});

export const { handleChannelList, addChannel } = channelsSlice.actions;

export const channelsReducer = channelsSlice.reducer;
